/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Featured_Pagetitle1Inputs */

const zh_featured_pagetitle1 = /** @type {(inputs: Featured_Pagetitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`精选案例 - StudyOS`)
};

const en_featured_pagetitle1 = /** @type {(inputs: Featured_Pagetitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Featured Examples - StudyOS`)
};

const es_featured_pagetitle1 = /** @type {(inputs: Featured_Pagetitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ejemplos destacados - StudyOS`)
};

/**
* | output |
* | --- |
* | "Featured Examples - StudyOS" |
*
* @param {Featured_Pagetitle1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const featured_pagetitle1 = /** @type {((inputs?: Featured_Pagetitle1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Featured_Pagetitle1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_featured_pagetitle1(inputs)
	if (locale === "en") return en_featured_pagetitle1(inputs)
	return es_featured_pagetitle1(inputs)
});
export { featured_pagetitle1 as "featured_pageTitle" }